<template>
  <div class="resultsGroup">
    <div class="resultsGroup__loading" v-if="isPageLoading">
      <adx-loading-primary/>
    </div>
    <div v-if="!isPageLoading">
      <div class="resultsGroup__top">
        <div class="resultsGroup__top__header">
            <!-- <div class="resultsGroup__top__header__subtitle subhead">
            Showing result for :
            </div> -->
            <h1 class="resultsGroup__top__header__title large-title">
            {{routeInfo.title}}
            </h1>
            <!-- <p v-if="status != `400`" class="resultsGroup__top__header__total">
            Total listing {{totalListing}} items
            </p> -->
        </div>
        <div class="resultsGroup__top__filter">
            <div class="resultsGroup__top__filter__left">
            <template v-if="routeName == 'lifestyle'">
                <adx-dropdown-search @selected="selectedLocation" :list="locations"
                labelButton="Locations" :selected-value="selectedLocationValue"/>
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
                <adx-dropdown-checkbox @selected="selectedSocial"
                :list="social"
                :color="'pink'"
                labelButton="Social"
                :title="`Social`" :default="selectedSocialValue" />
                <adx-dropdown-checkbox @selected="selectedProfile"
                :list="profile"
                :color="'pink'"
                labelButton="Profile"
                :title="`Profile`" :default="selectedProfileValue" />
            </template>
            <template v-else-if="routeName == 'malls'">
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
            </template>
            <template v-else-if="routeName == 'spbu'">
                <adx-dropdown-checkbox @selected="selectedSurrounding"
                :list="surroundings"
                :color="'pink'"
                labelButton="Surrounding"
                :title="`Surrounding`" :default="selectedSurroundingValue" />
            </template>
            <template v-else-if="routeName == 'airport'">
                <adx-dropdown-search @selected="selectedLocation" :list="locations"
                labelButton="Locations" :selected-value="selectedLocationValue"/>
                <adx-dropdown-checkbox @selected="selectedBrand"
                :list="brands"
                :color="'pink'"
                labelButton="Brands"
                :title="`Brands`" :default="selectedBrandValue" />
            </template>
            <div class="resultsGroup__top__filter__left__sort--mobile">
                <button class="btn-regular" :class="[labelType == 'Type' ? 'secondary' : 'teal']" @click="showQuickFilter = true">{{labelType | capitalizing}}</button>
            </div>
            <div v-if="filtered" class="reset">
                <button class="btn-regular link" @click="resetFilter">Reset</button>
            </div>
            </div>
            <div v-if="selectedQuickFilterValue != 'ALL'" class="resultsGroup__top__filter__right">
            <span class="subhead">Sort by :</span>
            <div>
                <adx-dropdown-sort :value.sync="selectedSortValue" :type="true" :label="`Select sort`" :options="sortOptions" />
            </div>
            </div>
        </div>
      </div>
      <template v-if="status == `400`">
            <div class="resultsGroup__middle__alert">
            <p class="subhead">We didn’t find any match for : <b>“{{this.searchValue}}”</b></p>
            <p class="subhead"><b> Tips :</b> Keep calm hope we can add this name in the future. :) • Try checking your spelling or use more general terms</p>
            </div>
            <div class="resultsGroup__middle__maybe">
                <h6 class="subhead">Maybe you want check our interesting location :</h6>
            </div>
        </template>
      <div class="resultsGroup__bottom">
        <div class="resultsGroup__bottom__content">
            <div class="resultsGroup__bottom__content__listings">
                <template v-if="!isSubLoading">
                    <adx-list-result @item-clicked="gotoDetail($event)" :data='itemsCategory' :category="selectedQuickName"
                    :property="selectedSubQuickName" @createNew="createNew"
                    @createNewCampaign="createNewCampaign" :isAction="true"
                    :menuList="expansionList" :loading="isSubLoading">
                        <template slot="loading" v-if="!isPageLoading || !isSubLoading">
                        <template v-if="!isLoading">
                            <div v-if="next" class="resultsGroup__bottom__content__listings__paging" @click.stop="loadInfiniteData">
                                <!-- <span class="resultsGroup__bottom__content__listings__paging__load">Show more</span> -->
                                <button class="btn-regular secondary"> <strong>Load More</strong> </button>
                            </div>
                            <div v-else class="resultsGroup__bottom__content__listings__paging">
                                <span class="resultsGroup__bottom__content__listings__paging__empty"> There is no more data </span>
                            </div>
                        </template>
                        <template v-else>
                            <adx-loading-primary />
                        </template>
                        </template>
                    </adx-list-result>
                </template>
                <template v-else>
                  <adx-loading-primary />
                </template>
            </div>
            <div class="resultsGroup__bottom__content__filter">
                <adx-quick-filter :list.sync="quickFilter" :value="selectedQuickFilterValue"
                @valueClicked="selectCategory"
                :subValue="selectedSubQuickValue" :defaultOpen="selectedQuickFilterValue"/>
            </div>
        </div>
      </div>
      <adx-modal v-if="showQuickFilter" title="Type" @modal-close="showQuickFilter = false">
        <div slot="content" class="content">
          <div class="resultsGroup__type">
            <ul>
              <li v-for="(item, index) in quickFilter" :key="index">
                <div class="resultsGroup__type__content subhead" @click.stop="selectType(item, index)">
                  {{item.label.charAt(0).toUpperCase() + item.label.substr(1)}}
                  <i v-if="item.subitem" :class="isTypeExpand.includes(index) ? 'icon-chevronup':'icon-chevrondown'"></i>
                </div>
                <div v-if="isTypeExpand.includes(index)" class="resultsGroup__type--child">
                  <ul>
                    <li v-for="(child, chilin) in item.subitem" :key="chilin"
                    @click.stop="selectSubType(child, item)" class="subhead">
                      {{child.label}}
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateSaved" :hide-close="true" title="Start to create saved" @modal-close="toggleModalCreate" type='small' :noTitle="true">
        <div class="resultsGroup__modal" slot="content">
          <div class="resultsGroup__modal__input">
            <input ref="input" type="text" @keyup="KeyUp">
            <label class="subhead">Folder Name</label>
          </div>
          <div class="resultsGroup__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCreate">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createFolder">Save</button>
          </div>
        </div>
      </adx-modal>
      <adx-modal v-if="isCreateCampaign" :hide-close="true" title="Start to create campaign" @modal-close="toggleModalCampaign" type='small' :noTitle="true">
        <div class="resultsGroup__modal" slot="content">
          <div class="resultsGroup__modal__input">
            <input ref="input" type="text" @keyup="KeyUpCampaign">
            <label class="subhead">Campaign Name</label>
          </div>
          <div class="resultsGroup__modal__buttons">
            <button class="btn-regular secondary" @click="toggleModalCampaign">Cancel</button>
            <button class="btn-regular primary" :disabled="newTitle === ''"
            @click="createCampaign">Save</button>
          </div>
        </div>
      </adx-modal>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import ListGroup from '@/views/Search/ResultsGroup/ListGroup'
import ListResult from '@/views/Search/ResultsGroup/ListResult'
import QuickFilter from '@/components/QuickFilter'
import DropdownSearch from '@/components/Dropdown/SearchDropdown'
import DropdownCheckbox from '@/components/Dropdown/CheckboxDropdownCustom'
import DropdownList from '@/components/Dropdown/ListDropdown'
import DropdownSort from '@/components/Form/SelectDropdown'
import InfiniteLoading from 'vue-infinite-loading'
import ExpandableResult from '@/components/ExpandableListItems'
import Modal from '@/components/Modal'

import api from '@/api'
import { apiV2 } from '@/api/urls'
import { fromKeys, mapListFilter } from '@/lib/transformer'
import { deviceParams } from '@/api/params'
import types from '@/lib/types'
import LoadingPrimary from '@/components/Loading/Primary'
import { mapGetters } from 'vuex'

export default {
  name: 'adx-results-group',
  components: {
    'adx-list-group': ListGroup,
    'adx-list': ListResult,
    'adx-quick-filter': QuickFilter,
    'adx-dropdown-list': DropdownList,
    'adx-dropdown-search': DropdownSearch,
    'adx-dropdown-checkbox': DropdownCheckbox,
    'adx-dropdown-sort': DropdownSort,
    'adx-list-result': ExpandableResult,
    'infinite-loading': InfiniteLoading,
    'adx-modal': Modal,
    'adx-loading-primary': LoadingPrimary,
  },
  props: {

  },
  data() {
    return {
      items: [],
      totalListing: 0,
      next: null,
      count: null,
      isLoading: false,
      page: 2,
      headers: [
        'items',
        'placement',
        'daily visitor',
        'price'
      ],
      searchValue: ``,
      quickFilter: [],
      selectedQuickFilterValue: `ALL`,
      selectedSubQuickValue: ``,
      itemsCategory: ``,
      status: ``,
      locations: [],
      sortOptions: types.sortOrdering,
      selectedSortValue: `-traffic`,
      selectedLocationValue: '',
      brands: [],
      selectedBrandValue: [],
      social: [],
      selectedSocialValue: [],
      profile: [],
      selectedProfileValue: [],
      surroundings: [],
      selectedSurroundingValue: [],
      selectedTypeValue: '',
      selectedTypeName: '',
      selectedQuickName: '',
      selectedSubQuickName: '',
      showQuickFilter: false,
      isTypeExpand: [],
      labelType: 'Type',
      isPageLoading: false,
      isSubLoading: false,
      isCreateCampaign: false,
      isCreateSaved: false,
      createParams: {},
      newTitle: '',
      query: '',
      categories: [],
      expansionList: [],
    }
  },
  computed: {
    routeName: function(){
        return this.$route.params.name
    },
    routeInfo: function(){
       if (this.routeName == 'lifestyle'){
        return {
         code: `LS`,
         title: `Lifestyle`
        }
       } else if (this.routeName == 'malls'){
        return {
         code: `ML`,
         title: `Malls`
        }
       } else if (this.routeName == 'airport'){
        return {
         code: `AR`,
         title: `Airport Lounge`
        }
       } else if (this.routeName == 'spbu'){
        return {
         code: `BU`,
         title: `SPBU`
        }
       } else if (this.routeName == 'inflight') {
        return {
         code: `IF`,
         title: `Inflight`
        }
       } else if (this.routeName == 'airmedia') {
        return {
         code: `AM`,
         title: `Airport Media`
        }
       }
       return {
        code: ``,
        title: ``
       }
    },
    filtered: function() {
      let filtered = false
      let querys = this.$route.query
      Object.keys(querys).forEach(function(key) {
        if (key !== 'sort' && key !== 'category' &&
        key !== 'property_type' && key !== 'search' &&
        querys[key]) {
            filtered = true
            }
      });

      // if (
      //   this.selectedTypeValue ||
      //   this.selectedProfileValue.length ||
      //   this.selectedBrandValue.length ||
      //   this.selectedSocialValue.length ||
      //   this.selectedLocationValue
      // ) filtered = true

      return filtered
    },
    getFilterParams: function () {
      // TO DO: quick filter
      //for malls, spbu => location
      //for lifestyle => property_type
      //for airport => departure_type

      const params = {
        property_type: this.selectedSubQuickValue || undefined,
        category: this.selectedQuickFilterValue === 'ALL' ? undefined : this.selectedQuickFilterValue,
        query: this.status == 400 && this.selectedQuickFilterValue != 'ALL' ? undefined : this.searchValue,
        sort: this.selectedSortValue || undefined,
        surrounding: this.selectedSurroundingValue.join(`,`) || undefined,
        profile: this.selectedProfileValue.join(`,`) || undefined,
        brand: this.selectedBrandValue.join(`,`) || undefined,
        social: this.selectedSocialValue.join(`,`) || undefined,
        location: this.selectedLocationValue || undefined
      }
      if (this.$router){
       this.$router.replace({
         query: params
       })
      }
      return params
    },
    ...mapGetters ({
      token: 'token'
    }),
  },
  watch: {
   routeName: function(){
    this.getFilter()
    this.$nextTick(() => {
        this.loadCategory()
      });
   },
    selectedSortValue: function () {
      this.$nextTick(() => {
        this.checkLoad()
      });
    },
    selectedQuickFilterValue: function (newValue, oldValue) {
      if (oldValue !== 'ALL') {
        this.resetSpecificFilter()
        this.$nextTick(() => {
          this.checkLoad()
        })
      } else {
        this.selectedSortValue = `-traffic`
        this.getFilter()
        this.$nextTick(() => {
          this.checkLoad()
        })
      }
    },
    searchValue: function() {
      this.$nextTick(() => {
        this.checkLoad()
      });
    }
  },
  beforeCreate() {

  },
  created() {
    this.getFilter()
    this.getCategories()
  },
  beforeMount() {
    this.loadSavedandCampaign()
  },
  mounted() {
    const query = this.$route.query
    if (query) {
      this.setFilterQuery(query)
      this.$nextTick(() => {
        // this.checkLoad()
        Vue.$broker.$on("app-search", this.newSearch.bind(this))
      })
    } else {
      // this.checkLoad()
      Vue.$broker.$on("app-search", this.newSearch.bind(this))
    }
  },
  beforeUpdate() {

  },
  updated() {
  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    selectSubCategory(item, parent) {
      this.selectedQuickFilterValue = parent.value
      this.selectedSubQuickValue = item.value
      this.setCategoryandSubCategory(parent.value, item.value)
      this.$nextTick(() => {
        this.loadCategory()
      })
    },
    selectCategory(item) {
        this.selectedQuickFilterValue = item
        this.selectedSubQuickValue = ``
        this.setCategoryandSubCategory(item, '')

        this.$nextTick(() => {
          this.checkLoad()
        });
    },
    setCategoryandSubCategory(category, subCategory) {
      let title = ``
      let subTitle = ``
      this.categories.forEach(function (item) {
        if (item.value == category) {
          title = item.title;
          if (subCategory && item.subcategories) {
            item.subcategories.forEach(function (subitem) {
              if (subitem.value == subCategory) {
                subTitle = subitem.title;
              }
            })
          }
        }
      })
      this.selectedQuickName = title
      this.selectedSubQuickName = subTitle
    },
    loadSavedandCampaign() {
      while(this.expansionList.length > 0) {
        this.expansionList.pop()
      }
      this.expansionList = [
        {
          "id": 0,
          "name": "Add to saved folder",
          "value": "saved",
          "items": [
            {
              "name": "Create new saved",
              "value": 0
            }
          ]
        },
        {
          "id": 1,
          "name": "Add to campaign",
          "value": "campaign",
          "items": [
            {
              "name": "Create new campaign",
              "value": 0
            }
          ]
        },
        {
          "id": 2,
          "name": "Go to Detail page",
          "value": "detail"
        }
      ]
      this.loadSaved()
      this.loadCampaigns()
    },
    loadSaved() {
      (async () => {
        const response = await api.get(apiV2.saved, { needToken: true })
        if (response.status === 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[0]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        }
      })();
    },
    loadCampaigns() {
      (async () => {
        const response = await api.get(apiV2.draftCampaigns, { needToken: true })
        if (response.status == 200) {
          const { data } = response
          data.map(el => {
            this.expansionList[1]['items'].push({
              "name": el.title,
              "value": el.id
            })
          })
        } else {
          // this.error = response.data.error
        }
      })();
    },
    createNewCampaign(params) {
      this.createParams = params
      this.isCreateCampaign = true
    },
    createCampaign() {
      (async () => {
        const data = {
          title: this.newTitle,
          campaign_channel: [
            {
              name: this.createParams.category,
              list_id: [this.createParams.device_id]
            }
          ]
        };
        const response = await api.post(apiV2.campaignNew, data, { needToken: true })
        this.isCreateCampaign = false
        if (response.status == 201) {
          this.isCreateCampaign = false
          this.$notify({
            group: 'saved',
            title: 'Added to campaign',
            text: this.createParams.location_name + ' has been added to ' + this.newTitle,
            type: 'success'
          });
          this.loadSavedandCampaign()
        } else {
          this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'sorry something went wrong!',
            type: 'warn'
          });
        }
      })();
    },
    createFolder(){
      (async () => {
        this.createParams['title'] = this.newTitle
        const response = await api.post(apiV2.saved, this.createParams, { needToken: true })
        if (response.status == 201) {
          this.isCreateSaved = false
          this.loadSavedandCampaign()
        }
      })();
    },
    KeyUp(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createFolder()
      }
    },
    KeyUpCampaign(ev){
      this.newTitle = this.$refs.input.value
      if (ev.keyCode == 13) {
        this.createCampaign()
      }
    },
    createNew(params) {
      this.createParams = params
      this.isCreateSaved = true
    },
    toggleModalCreate() {
      this.isCreateSaved = !this.isCreateSaved
    },
    toggleModalCampaign() {
      this.isCreateCampaign = !this.isCreateCampaign
    },
    newSearch(item) {
      this.resetFilter()
      this.searchValue = item
    },
    getSearch(item) {
      this.searchValue = item
    },
    selectType(item, index){
      if (item.subitem) {
        const include = this.isTypeExpand.includes(index)
        this.isTypeExpand = []
        if (!include) this.isTypeExpand.push(index)
      } else {
        this.showQuickFilter = false
      }
      this.selectedQuickFilterValue = item.value
      this.labelType = item.label
    },
    selectSubType(item, parent) {
      this.labelType = item.label.charAt(0).toUpperCase() + item.label.substr(1)
      this.showQuickFilter = false
      this.labelType = item.label
      this.selectSubCategory(item, parent)
    },
    checkLoad() {
      if(this.selectedQuickFilterValue == 'ALL'){
        this.resetFilter()
        // this.loadData()
        this.loadCategory()
      }else {
        this.loadCategory()
      }
    },
    resetFilter() {
      this.selectedSubQuickValue = undefined
      this.selectedQuickFilterValue = 'ALL'
      this.selectedSortValue = undefined
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedSurroundingValue = []
      this.selectedLocationValue = undefined
      this.getFilterParams
    },
    resetSpecificFilter() {
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedSurroundingValue = []
      this.selectedLocationValue = undefined
      this.selectedSubQuickValue = ``
      this.getFilter()
    },
    loadData() {

      (async () => {
        this.isPageLoading = true
        const searchValue = this.searchValue
        let params = {
          query: searchValue,
          category: this.routeName
        }

        let dataParam = {
          text: searchValue
        }

        let args = {}
        if (this.token) {
          args = { needToken: true }
        }
        const response = await api.post(apiV2.searchHistory, dataParam, args)
        const { data, status } = await api.get(apiV2.searchResult, { params: params })

        // const lists = data.lists
        // let items = await Object.keys(lists).map(function(key, index) {
        //   return {
        //     title: key,
        //     lists: lists[key]
        //   }
        // });

        this.items = data.results
        this.status = status
        let totalListing = 0
        await this.items.forEach(function (item) {
        //   totalListing += item.lists.length
          totalListing += item.media.length
        })
        
        this.totalListing = totalListing
        this.isPageLoading = false
      })();
    },
    loadCategory() {
      (async () => {
        this.itemsCategory = []
        this.isSubLoading = true
        const searchValue = this.searchValue
        let params = {
          ...this.getFilterParams,
          category: this.routeName
        }
        const { data , status} = await api.get(apiV2.searchResult, { params })
        if (data) {
            this.itemsCategory = data.results || []
            this.count = data.count
            this.next = data.next
            this.totalListing = this.itemsCategory.length
        }
        this.page = 2
        this.isSubLoading = false
        this.status = status
        
      })();
    },
    async loadInfiniteData($state) {
      if (this.$data.next) {
        this.$data.isLoading = true
        let params = {
          page: this.$data.page,
          ...this.getFilterParams
        }
        const { data } = await api.get(apiV2.searchResult, { params })
        if (data.results) {
          this.$data.itemsCategory = this.$data.itemsCategory.concat(data.results)
          this.totalListing = this.$data.itemsCategory.length
          this.$data.count = data.count
          this.$data.next = data.next
          // $state.loaded();
          // if (!data.next) {
          //   $state.complete()
          // }
        } else {
          // $state.complete()
        }
        this.$data.page += 1
        this.$data.isLoading = false
      }
    },
    getFilter () {
      (async () => {
        const { data } = await api.get(apiV2.deviceFilters, {
          params: { category: this.routeInfo.code }
        })
        this.mapFilter(data)
      })();
    },
    getCategories() {
      let file = `/static/data/categories.json`;
      (async () => {
        let request = await fetch(new Request(file));
        let data = await request.json();

        this.categories = data.categories;
        this.setCategoryandSubCategory(this.selectedQuickFilterValue, this.selectedSubQuickValue);
      })();
    },
    mapFilter (data) {
      const brands = mapListFilter({ obj: data.brands, id: `id`, value: `id`, label: `title`})
      const social = mapListFilter({ obj: data.social, id: `id`, value: `level`, label: `title`})
      const profile = mapListFilter({ obj: data.profile, id: `id`, value: `id`, label: `name`})
      this.brands = brands
      this.social = social
      this.profile = profile
      this.surroundings = fromKeys(data.surrounding)
      this.locations = data.cities
      if (this.routeName == 'spbu' || this.routeName == 'malls'){
       this.mapQuickFilter(this.locations, 'malls')
      } else if (this.routeName == 'lifestyle'){
       this.mapQuickFilter(data.lifestyle, 'lifestyle')
      } else if (this.routeName == 'airport') {
       this.mapQuickFilter(data.departure_type, 'airport')
      }
    },
    mapQuickFilter(quickFilterOptions, type){
     let category = quickFilterOptions
     let filter = []
     if (type == 'malls'){
      filter = category.map(el => {
        const newObj = {
         label: el.title,
         value: el.id,
        }
       return newObj
      })
     } else if (type == 'airport') {
       filter = [
        {
         label: 'Internasional',
         value: 'IT'
        },
        {
         label: 'Domestic',
         value: 'DO'
        }
       ]
     } else {
       filter = category.map(el => {
        const newObj = {
         label: el.name,
         value: el.value,
        }
        return newObj
       })
     }
      
      filter.unshift({
          label: `All`,
          value: `ALL`
      })
      this.quickFilter = filter
      // this.quickFilter.sort((a, b) => {
      //     let orderingRule = ['lifestyle', 'spbu', 'malls', 'airport']
      //     return orderingRule.indexOf(a.value) - orderingRule.indexOf(b.value)
      //     })
      // this.setLabelType({
      //     cat: this.selectedQuickFilterValue,
      //     sub: this.selectedSubQuickValue
      // })
    },
    selectedBrand(item){
      this.selectedBrandValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedSocial(item){
      this.selectedSocialValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedSort(item){
      if (this.selectedSortValue === item.value) {
        this.selectedSortValue = `-traffic`
      } else {
        this.selectedSortValue = item.value
      }
    },
    selectedProfile(item){
      this.selectedProfileValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedSurrounding(item){
      this.selectedSurroundingValue = item
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    selectedLocation(item){
      this.selectedLocationValue = item.id.toString()
      this.$nextTick(() => {
        this.loadCategory()
      });
    },
    showAllClicked(item){
      this.selectedQuickFilterValue = item
      this.setCategoryandSubCategory(item, '')
    },
    setFilterQuery (query) {
      Object.keys(query).map((index, element) => {
        const variable = types.searchFilter[index]
        this.$data[variable] = ( () => {
          switch (variable) {
            case `selectedSortValue`:
            case `selectedLocationValue`:
            case `searchValue`:
            case `selectedQuickFilterValue`:
            case `selectedSubQuickValue`:
              return query[index]
              break
            default:
              if (query[index]) return query[index].split(`,`)
          }
        })()
      })
    },
    setLabelType({ cat, sub }) {
      if (sub) {
        const parent = this.quickFilter.filter(el => el.subitem).pop()
        this.labelType = parent.subitem.filter( el => {
          return el.value === sub
        }).pop().label || `Type`
      } else {
        this.labelType = this.quickFilter.filter( el => {
          return el.value === cat
        }).pop().label || `Type`
      }
    },
    resetFilter2() {
      this.selectedSurroundingValue = []
      this.selectedProfileValue = []
      this.selectedBrandValue = []
      this.selectedSocialValue = []
      this.selectedLocationValue = ''

      const params = {
        surrounding: undefined,
        profile: undefined,
        brand: undefined,
        social: undefined,
        location: undefined
      }
      if (this.$router) {
       this.$router.replace({
         query: params
       })
      } 
    },
    gotoDetail({ item }) {
      let category = `detail${item.category_display}`
      if (item.pub_id) {
        const { pub_id } = item
        let route = this.$router.resolve({ name: category, params: { pub_id : pub_id } });
        window.open(route.href, '_blank');
      }
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>